import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, headers: { 'Content-Type': 'application/json' } });

export const submitContact = (data) => api.post('/contact', data).then((r) => r.data);
export const submitSpeaking = (data) => api.post('/speaking', data).then((r) => r.data);
export const subscribeNewsletter = (email, source = 'website', firstName = null) =>
  api.post('/newsletter', { email, source, first_name: firstName, consent_given: true }).then((r) => r.data);

export const joinWaitlist = ({ product, name, email, source = 'website' }) =>
  api.post('/waitlist', { product, name, email, source }).then((r) => r.data);
